var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"reporting-container"},[_c('Tabs',{attrs:{"tabs":_vm.tabs,"level":1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }